import type { Handlers } from '@/types/Metrics';
import { AppsflyerEvent, AppsflyerSetUidEvent } from '~/shared/NativeBridge';

/**
 * Handler do tracker AppsFlyer. Diferente dos outros trackers (Facebook,
 * Kwai, Taboola, GTM) que disparam pixels no DOM do navegador, este
 * handler envia o evento via ponte NativeWebView para o app nativo (RN),
 * que chama appsFlyer.logEvent.
 *
 * Se o payload contiver `_customer_user_id`, dispara setCustomerUserId
 * ANTES do logEvent. Cobre a janela de timing em que o watcher reativo
 * ainda nao executou (ex.: primeiro evento de signup, primeiro login).
 * Esse campo nao vai pro event_value do evento.
 *
 * Comportamento fora do app (browser web normal):
 *   dispatch() retorna false silenciosamente, no-op.
 */
export default function (args: Handlers['appsflyer']) {
  const [eventName, parameters] = args;

  if (!eventName) {
    console.warn('AppsFlyer tracking: eventName é obrigatório');

    return;
  }

  try {
    const { _customer_user_id, ...eventValues } = parameters ?? {};

    if (
      _customer_user_id !== undefined &&
      _customer_user_id !== null &&
      _customer_user_id !== ''
    ) {
      new AppsflyerSetUidEvent(_customer_user_id as string | number).dispatch();
    }

    new AppsflyerEvent(eventName, eventValues).dispatch();
  } catch (err) {
    console.error('Error executing AppsFlyer tracking:', err);
  }
}
